export default __webpack_public_path__ + "static/media/zid application.80bf0d90.png";